import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, LinearProgress, DialogActions, DialogTitle } from '@material-ui/core';
import { DynamicForm } from '../DynamicForm';
import * as v from '../../helpers/validation';

import { createAgent } from '../../services';

const AgentCreateForm = ({ open, setOpen, client }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);

  const inputs = [
    {
      inputType: 'text',
      field: 'agentCode',
      label: 'Agent Code',
    },
    {
      inputType: 'text',
      field: 'agentName',
      label: 'Agency Name',
      validate: [v.required()],
    },
    {
      inputType: 'text',
      field: 'agentPhone',
      label: 'Agent Phone',
      validate: [v.required()],
    },
    {
      inputType: 'text',
      field: 'agentEmail',
      label: 'Agent Email',
      validate: [v.required()],
    }
  ];

  const createAgentAsync = formData => {
    return createAgent({
      ...formData,
      clientId: client?.id,
    });
  };

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={() => setOpen(false)}
      aria-labelledby="agent-create-title"
      autoScrollBodyContent={false}
      contentStyle={{ width: '100%', maxWidth: 'none' }}
    >
      <DialogTitle>
        Create an Agent:{' '}
        <b>
          {client?.name} {client?.code && `(${client.code})`}
        </b>
      </DialogTitle>
      <DialogContent
        dividers
        style={{
          minWidth: 500,
          borderTop: '0.8px solid #ddd',
          borderBottom: '0.8px solid #ddd',
          paddingTop: 20,
          pointerEvents: isSubmitting ? 'none' : 'auto',
          opacity: isSubmitting ? 0.5 : 1,
        }}
      >
        <DynamicForm
          inputs={inputs}
          mode={'CREATE'}
          hideSubmitButton
          onSave={createAgentAsync}
          onSaveSuccess={() => setOpen(false)}
          customActionsPanel={({
            isSubmitting,
            onSave: handleSave,
            onDelete: handleDelete,
            submitError,
            submitSuccess,
          }) => {
            return (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: 25,
                }}
              >
                <Button
                  onClick={() => setOpen(false)}
                  variant="contained"
                  style={{ backgroundColor: '#315382', color: 'white' }}
                >
                  Cancel
                </Button>
                <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
                  {isSubmitting && <LinearProgress />}
                  {submitMessage && <div className="text-center">{submitMessage}</div>}
                </div>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSave}
                  variant="contained"
                  style={{ backgroundColor: '#315382', color: 'white' }}
                >
                  Create
                </Button>
              </div>
            );
          }}
          // onSave={onSave}
        />
      </DialogContent>
    </Dialog>
  );
};

AgentCreateForm.defaultProps = {};
AgentCreateForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  client: PropTypes.object.isRequired,
};

export default AgentCreateForm;
